import type { PropsWithChildren } from "react"
import React from "react"
import { productCardStyle } from "./ProductCard.css"
import type { ProductCardDataType } from "./types"

type Props = PropsWithChildren & {
  product: Pick<ProductCardDataType, "productName" | "href">
  onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

export const ProductCard: React.FC<Props> = ({
  children,
  product,
  onClick,
}) => {
  return (
    <a
      href={product.href}
      title={product.productName}
      className={productCardStyle}
      onClick={(e) => onClick?.(e)}
      data-testid="product-card"
    >
      {children}
    </a>
  )
}
